export const payeeAccountsPtBr = {
  addTitle: 'Adicionar dados bancários',
  editTitle: 'Editar dados bancários',
  subtitleVendor: 'Registre como pagar este fornecedor',
  subtitleEmployee: 'Registre como pagar este colaborador',
  description: 'Escolha o método de pagamento e informe os dados bancários do favorecido.',
  payeeVendor: 'Fornecedor',
  payeeEmployee: 'Colaborador',

  defaultMethod: 'Método padrão',
  defaultMethodHintVendor: 'Usado automaticamente ao pagar este fornecedor',
  defaultMethodHintEmployee: 'Usado automaticamente ao pagar este colaborador',

  method: 'Método de pagamento',
  methodPix: 'Chave PIX',
  methodPixHint: 'Pagamento por chave, sem agência e conta',
  methodTransfer: 'Transferência',
  methodTransferHint: 'TED ou DOC com agência e conta',

  pixKey: 'Chave PIX',
  pixKeyAutoDetected: 'Tipo detectado automaticamente pelo formato da chave',
  pixKeyPlaceholder: '12.345.678/0001-95',
  optionalPixKey: 'Esta conta também tem chave PIX?',
  optionalPixKeyPlaceholder: 'Opcional',
  optionalPixKeyHint: 'Informe para pagar a mesma conta por PIX, sem cadastrar um segundo método.',

  bank: 'Banco',
  bankSearchPlaceholder: 'Buscar por nome ou código...',
  agency: 'Agência',
  agencyDigit: 'Dígito',
  account: 'Conta',
  accountDigit: 'Dígito',
  accountType: 'Tipo de conta',
  accountTypes: {
    CHECKING: 'Corrente',
    SAVINGS: 'Poupança',
    PAYMENT: 'Pagamento',
  },
  holder: 'Titular da conta',
  holderPlaceholder: 'Deixe em branco para usar o nome do favorecido',

  country: 'País da conta',
  countryBR: 'Brasil',
  countryUS: 'Estados Unidos',
  routingNumber: 'Routing number (ABA)',
  routingNumberHint: '9 dígitos, como aparece no cheque ou no extrato',
  usAccountNumber: 'Número da conta',
  usAccountNumberHint: 'Até 17 dígitos',
  accountClass: 'Tipo de conta',
  accountClasses: {
    CHECKING: 'Corrente',
    SAVINGS: 'Poupança',
  },
  usAccountNote: 'Conta nos EUA: recebe por transferência ACH em dólar.',
  gatewayLocked:
    'Esta conta já está registrada no gateway de pagamento. Para alterar o routing number, o número da conta ou o tipo de conta, cadastre uma nova conta.',

  issues: {
    ROUTING_INVALID: 'O routing number deve ter 9 dígitos.',
    US_ACCOUNT_INVALID: 'Informe o número da conta com até 17 dígitos.',
    US_ACCOUNT_DUPLICATE: 'Já existe uma conta com este routing number e número de conta.',
    PIX_KEY_REQUIRED: 'Informe a chave PIX.',
    PIX_KEY_DUPLICATE: 'Já existe um método PIX com esta chave.',
    BANK_REQUIRED: 'Selecione o banco.',
    AGENCY_REQUIRED: 'Informe a agência.',
    ACCOUNT_REQUIRED: 'Informe o número da conta.',
    ACCOUNT_DIGIT_REQUIRED: 'Informe o dígito da conta.',
    TRANSFER_DUPLICATE: 'Já existe uma conta com este banco, agência e conta.',
  },

  /** What the server says is wrong with agência/conta/dígito, by issue code (used when it sends no sentence). */
  serverIssues: {
    AGENCY_MISSING: 'Informe a agência com até 4 dígitos.',
    AGENCY_HAS_CHECK_DIGIT:
      'A agência parece trazer o dígito verificador. Informe a agência com até 4 dígitos e o dígito no campo próprio.',
    ACCOUNT_MISSING: 'Informe o número da conta.',
    ACCOUNT_TOO_LONG:
      'A conta tem dígitos demais (máximo de 12). Informe a conta sem o dígito verificador.',
    ACCOUNT_DIGIT_MISSING: 'Informe o dígito verificador da conta (1 ou 2 caracteres).',
    ACCOUNT_DIGIT_TOO_LONG: 'O dígito da conta tem caracteres demais (máximo de 2).',
  },

  vendorForm: {
    bankInfoTitle: 'Informações bancárias',
    bankRequired: 'Banco',
    agency: 'Agência',
    agencyDigit: 'Dígito da agência',
    accountType: 'Tipo de conta',
    accountNumber: 'Número da conta',
    accountDigit: 'Dígito da conta',
    holderName: 'Nome do titular',
    bankCodeInvalid: 'O código do banco deve ter 3 dígitos.',
    incompleteBankData: 'Preencha os dados bancários ou cadastre apenas com chave PIX.',
    pixKeyRequired: 'Informe o tipo e a chave PIX para habilitar o PIX.',
    pixTitle: 'Configuração PIX',
    pixEnable: 'Habilitar PIX',
    pixKeyType: 'Tipo de chave PIX',
    pixKeyTypeSelect: 'Selecione',
    pixKeyTypes: {
      CNPJ: 'CNPJ',
      CPF: 'CPF',
      EMAIL: 'E-mail',
      PHONE: 'Telefone',
      RANDOM: 'Chave aleatória',
    },
    statusTitle: 'Situação',
    isDefault: 'Conta padrão',
    isActive: 'Ativa',
    update: 'Atualizar',
    add: 'Adicionar',
  },

  cancel: 'Cancelar',
  save: 'Salvar',
  saving: 'Salvando...',
  back: 'Voltar',

  discardTitle: 'Descartar alterações?',
  discardDescription: 'As alterações feitas neste formulário serão perdidas.',
  discardConfirm: 'Descartar',
  discardKeepEditing: 'Continuar editando',
};

export const payeeAccountsEn: typeof payeeAccountsPtBr = {
  addTitle: 'Add bank details',
  editTitle: 'Edit bank details',
  subtitleVendor: 'Record how to pay this vendor',
  subtitleEmployee: 'Record how to pay this employee',
  description: 'Choose the payment method and fill in the payee bank details.',
  payeeVendor: 'Vendor',
  payeeEmployee: 'Employee',

  defaultMethod: 'Default method',
  defaultMethodHintVendor: 'Used automatically when paying this vendor',
  defaultMethodHintEmployee: 'Used automatically when paying this employee',

  method: 'Payment method',
  methodPix: 'PIX key',
  methodPixHint: 'Paid by key, with no branch and account',
  methodTransfer: 'Transfer',
  methodTransferHint: 'TED or DOC with branch and account',

  pixKey: 'PIX key',
  pixKeyAutoDetected: 'Type detected automatically from the key format',
  pixKeyPlaceholder: '12.345.678/0001-95',
  optionalPixKey: 'Does this account also have a PIX key?',
  optionalPixKeyPlaceholder: 'Optional',
  optionalPixKeyHint: 'Fill it in to pay the same account by PIX, without a second method.',

  bank: 'Bank',
  bankSearchPlaceholder: 'Search by name or code...',
  agency: 'Branch',
  agencyDigit: 'Digit',
  account: 'Account',
  accountDigit: 'Digit',
  accountType: 'Account type',
  accountTypes: {
    CHECKING: 'Checking',
    SAVINGS: 'Savings',
    PAYMENT: 'Payment',
  },
  holder: 'Account holder',
  holderPlaceholder: 'Leave blank to use the payee name',

  country: 'Account country',
  countryBR: 'Brazil',
  countryUS: 'United States',
  routingNumber: 'Routing number (ABA)',
  routingNumberHint: '9 digits, as printed on the check or statement',
  usAccountNumber: 'Account number',
  usAccountNumberHint: 'Up to 17 digits',
  accountClass: 'Account type',
  accountClasses: {
    CHECKING: 'Checking',
    SAVINGS: 'Savings',
  },
  usAccountNote: 'US account: paid by ACH transfer in dollars.',
  gatewayLocked:
    'This account is already registered at the payment gateway. To change the routing number, account number or account type, create a new account.',

  issues: {
    ROUTING_INVALID: 'The routing number must have 9 digits.',
    US_ACCOUNT_INVALID: 'Enter the account number with up to 17 digits.',
    US_ACCOUNT_DUPLICATE: 'This payee already has an account with this routing number and number.',
    PIX_KEY_REQUIRED: 'Enter the PIX key.',
    PIX_KEY_DUPLICATE: 'This payee already has a PIX method with this key.',
    BANK_REQUIRED: 'Select the bank.',
    AGENCY_REQUIRED: 'Enter the branch.',
    ACCOUNT_REQUIRED: 'Enter the account number.',
    ACCOUNT_DIGIT_REQUIRED: 'Enter the account check digit.',
    TRANSFER_DUPLICATE: 'This payee already has an account with this bank, branch and number.',
  },

  /** What the server says is wrong with branch/account/digit, by issue code (used when it sends no sentence). */
  serverIssues: {
    AGENCY_MISSING: 'Enter the branch with up to 4 digits.',
    AGENCY_HAS_CHECK_DIGIT:
      'The branch looks like it carries its check digit. Enter the branch with up to 4 digits and the digit in its own field.',
    ACCOUNT_MISSING: 'Enter the account number.',
    ACCOUNT_TOO_LONG:
      'The account has too many digits (maximum 12). Enter the account without its check digit.',
    ACCOUNT_DIGIT_MISSING: 'Enter the account check digit (1 or 2 characters).',
    ACCOUNT_DIGIT_TOO_LONG: 'The account check digit has too many characters (maximum 2).',
  },

  vendorForm: {
    bankInfoTitle: 'Bank details',
    bankRequired: 'Bank',
    agency: 'Branch',
    agencyDigit: 'Branch digit',
    accountType: 'Account type',
    accountNumber: 'Account number',
    accountDigit: 'Account digit',
    holderName: 'Account holder name',
    bankCodeInvalid: 'The bank code must have 3 digits.',
    incompleteBankData: 'Fill in the bank details or register with a PIX key only.',
    pixKeyRequired: 'Enter the PIX key type and key to enable PIX.',
    pixTitle: 'PIX settings',
    pixEnable: 'Enable PIX',
    pixKeyType: 'PIX key type',
    pixKeyTypeSelect: 'Select',
    pixKeyTypes: {
      CNPJ: 'CNPJ',
      CPF: 'CPF',
      EMAIL: 'Email',
      PHONE: 'Phone',
      RANDOM: 'Random key',
    },
    statusTitle: 'Status',
    isDefault: 'Default account',
    isActive: 'Active',
    update: 'Update',
    add: 'Add',
  },

  cancel: 'Cancel',
  save: 'Save',
  saving: 'Saving...',
  back: 'Back',

  discardTitle: 'Discard changes?',
  discardDescription: 'The changes made in this form will be lost.',
  discardConfirm: 'Discard',
  discardKeepEditing: 'Keep editing',
};
